import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
// Import the registration thunk
import { register_thunk } from "../redux/auth/authThunk";

const Register = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    address: "",
    bankDetails: {
      bankName: "",
      accountHolderName: "",
      accountNumber: "",
      routingNumber: "",
      swiftCode: "",
      ibanNumber: "",
    },
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.includes(".")) {
      const [parent, child] = name.split(".");
      setFormData({
        ...formData,
        [parent]: {
          ...formData[parent],
          [child]: value,
        },
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate name fields
    if (!formData.firstName?.trim()) {
      newErrors.firstName = "First name is required";
    }

    if (!formData.lastName?.trim()) {
      newErrors.lastName = "Last name is required";
    }

    // Validate email
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }

    // Validate password
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    // Validate confirm password
    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    // Validate address
    if (!formData.address.trim()) {
      newErrors.address = "Address is required";
    }

    // // Validate bank details
    // if (!formData.bankDetails.bankName.trim()) {
    //   newErrors["bankDetails.bankName"] = "Bank name is required";
    // }

    // if (!formData.bankDetails.accountHolderName.trim()) {
    //   newErrors["bankDetails.accountHolderName"] =
    //     "Account holder name is required";
    // }

    // if (!formData.bankDetails.accountNumber.trim()) {
    //   newErrors["bankDetails.accountNumber"] = "Account number is required";
    // }

    // if (!formData.bankDetails.routingNumber.trim()) {
    //   newErrors["bankDetails.routingNumber"] = "Routing number is required";
    // }

    // if (!formData.bankDetails.swiftCode.trim()) {
    //   newErrors["bankDetails.swiftCode"] = "SWIFT code is required";
    // }

    // if (!formData.bankDetails.ibanNumber.trim()) {
    //   newErrors["bankDetails.ibanNumber"] = "IBAN number is required";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsLoading(true);

      // Dispatch the thunk and get the resulting action
      const resultAction = await dispatch(register_thunk(formData));

      // Check if the action was fulfilled or rejected
      if (register_thunk.fulfilled.match(resultAction)) {
        // Success case
        console.log("Registration successful:", formData);
        navigate("/login");
      } else {
        // Error case - get the error message from the payload
        const errorMessage = resultAction.payload || "Registration failed";
        console.error("Registration failed:", errorMessage);

        // Set a general error or specific field errors based on the error message
        if (errorMessage.includes("Email already exists")) {
          setErrors({
            ...errors,
            email: "This email is already registered",
          });
        } else {
          setErrors({
            ...errors,
            general: errorMessage,
          });
        }
      }

      setIsLoading(false);
    }
  };

  return (
    <div className="max-h-[100vh] bg-gray-900 flex flex-col justify-center py-12 sm:px-6 lg:px-8 overflow-y-auto">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center mb-6">
          {/* <div className="h-16 w-16 bg-gradient-to-br from-purple-600 to-purple-700 rounded-xl flex items-center justify-center mt-10 shadow-lg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
              />
            </svg>
          </div> */}
        </div>
        <h2 className="text-center text-3xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-500">
          Create your account
        </h2>
        <p className="mt-2 text-center text-sm text-gray-400">
          Already have an account?{" "}
          <Link
            to="/login"
            className="font-medium text-purple-500 hover:text-purple-400 transition-colors"
          >
            Sign in
          </Link>
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-[#0F172A] py-8 px-4 shadow-xl shadow-black/20 sm:rounded-xl sm:px-10 border border-gray-800 max-h-[80vh] overflow-y-auto">
          <form className="space-y-6" onSubmit={handleSubmit}>
            {errors.general && (
              <div className="bg-red-900/50 border-l-4 border-red-500 p-4 rounded-r-lg">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg
                      className="h-5 w-5 text-red-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm text-red-400">{errors.general}</p>
                  </div>
                </div>
              </div>
            )}

            {/* Personal Information */}
            <div>
              <h3 className="text-lg font-medium text-white bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-500">
                Personal Information
              </h3>
              <div className="mt-4 space-y-4">
                {/* First Name */}
                <div>
                  <label
                    htmlFor="firstName"
                    className="block text-sm font-medium text-gray-300"
                  >
                    First Name
                  </label>
                  <div className="mt-1">
                    <input
                      id="firstName"
                      name="firstName"
                      type="text"
                      required
                      value={formData.firstName}
                      onChange={handleChange}
                      className={`appearance-none block w-full px-3 py-2 border ${
                        errors.firstName ? "border-red-500" : "border-gray-700"
                      } bg-gray-800/50 rounded-lg shadow-sm placeholder-gray-400 
                      focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500 
                      text-white transition-colors sm:text-sm`}
                    />
                    {errors.firstName && (
                      <p className="mt-2 text-sm text-red-500">
                        {errors.firstName}
                      </p>
                    )}
                  </div>
                </div>

                {/* Last Name */}
                <div>
                  <label
                    htmlFor="lastName"
                    className="block text-sm font-medium text-gray-300"
                  >
                    Last Name
                  </label>
                  <div className="mt-1">
                    <input
                      id="lastName"
                      name="lastName"
                      type="text"
                      required
                      value={formData.lastName}
                      onChange={handleChange}
                      className={`appearance-none block w-full px-3 py-2 border ${
                        errors.lastName ? "border-red-500" : "border-gray-700"
                      } bg-gray-800/50 rounded-lg shadow-sm placeholder-gray-400 
                      focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500 
                      text-white transition-colors sm:text-sm`}
                    />
                    {errors.lastName && (
                      <p className="mt-2 text-sm text-red-500">
                        {errors.lastName}
                      </p>
                    )}
                  </div>
                </div>

                {/* Email */}
                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-300"
                  >
                    Email address
                  </label>
                  <div className="mt-1">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className={`appearance-none block w-full px-3 py-2 border ${
                        errors.email ? "border-red-500" : "border-gray-700"
                      } bg-gray-800/50 rounded-lg shadow-sm placeholder-gray-400 
                      focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500 
                      text-white transition-colors sm:text-sm`}
                    />
                    {errors.email && (
                      <p className="mt-2 text-sm text-red-500">
                        {errors.email}
                      </p>
                    )}
                  </div>
                </div>

                {/* Password */}
                <div>
                  <label
                    htmlFor="password"
                    className="block text-sm font-medium text-gray-300"
                  >
                    Password
                  </label>
                  <div className="mt-1">
                    <input
                      id="password"
                      name="password"
                      type="password"
                      autoComplete="new-password"
                      required
                      value={formData.password}
                      onChange={handleChange}
                      className={`appearance-none block w-full px-3 py-2 border ${
                        errors.password ? "border-red-500" : "border-gray-700"
                      } bg-gray-800/50 rounded-lg shadow-sm placeholder-gray-400 
                      focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500 
                      text-white transition-colors sm:text-sm`}
                    />
                    {errors.password && (
                      <p className="mt-2 text-sm text-red-500">
                        {errors.password}
                      </p>
                    )}
                  </div>
                </div>

                {/* Confirm Password */}
                <div>
                  <label
                    htmlFor="confirmPassword"
                    className="block text-sm font-medium text-gray-300"
                  >
                    Confirm Password
                  </label>
                  <div className="mt-1">
                    <input
                      id="confirmPassword"
                      name="confirmPassword"
                      type="password"
                      autoComplete="new-password"
                      required
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      className={`appearance-none block w-full px-3 py-2 border ${
                        errors.confirmPassword
                          ? "border-red-500"
                          : "border-gray-700"
                      } bg-gray-800/50 rounded-lg shadow-sm placeholder-gray-400 
                      focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500 
                      text-white transition-colors sm:text-sm`}
                    />
                    {errors.confirmPassword && (
                      <p className="mt-2 text-sm text-red-500">
                        {errors.confirmPassword}
                      </p>
                    )}
                  </div>
                </div>

                {/* Address */}
                <div>
                  <label
                    htmlFor="address"
                    className="block text-sm font-medium text-gray-300"
                  >
                    Address
                  </label>
                  <div className="mt-1">
                    <textarea
                      id="address"
                      name="address"
                      rows="3"
                      required
                      value={formData.address}
                      onChange={handleChange}
                      className={`appearance-none block w-full px-3 py-2 border ${
                        errors.address ? "border-red-500" : "border-gray-700"
                      } bg-gray-800/50 rounded-lg shadow-sm placeholder-gray-400 
                      focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500 
                      text-white transition-colors sm:text-sm`}
                    />
                    {errors.address && (
                      <p className="mt-2 text-sm text-red-500">
                        {errors.address}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* <div>
              <h3 className="text-lg font-medium text-white bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-500">
                Bank Details
              </h3>
              <div className="mt-4 space-y-4">
                <div>
                  <label
                    htmlFor="bankDetails.bankName"
                    className="block text-sm font-medium text-gray-300"
                  >
                    Bank Name
                  </label>
                  <div className="mt-1">
                    <input
                      id="bankDetails.bankName"
                      name="bankDetails.bankName"
                      type="text"
                      required
                      value={formData.bankDetails.bankName}
                      onChange={handleChange}
                      className={`appearance-none block w-full px-3 py-2 border ${
                        errors["bankDetails.bankName"]
                          ? "border-red-500"
                          : "border-gray-700"
                      } bg-gray-800/50 rounded-lg shadow-sm placeholder-gray-400 
                      focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500 
                      text-white transition-colors sm:text-sm`}
                    />
                    {errors["bankDetails.bankName"] && (
                      <p className="mt-2 text-sm text-red-500">
                        {errors["bankDetails.bankName"]}
                      </p>
                    )}
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="bankDetails.accountHolderName"
                    className="block text-sm font-medium text-gray-300"
                  >
                    Account Holder Name
                  </label>
                  <div className="mt-1">
                    <input
                      id="bankDetails.accountHolderName"
                      name="bankDetails.accountHolderName"
                      type="text"
                      required
                      value={formData.bankDetails.accountHolderName}
                      onChange={handleChange}
                      className={`appearance-none block w-full px-3 py-2 border ${
                        errors["bankDetails.accountHolderName"]
                          ? "border-red-500"
                          : "border-gray-700"
                      } bg-gray-800/50 rounded-lg shadow-sm placeholder-gray-400 
                      focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500 
                      text-white transition-colors sm:text-sm`}
                    />
                    {errors["bankDetails.accountHolderName"] && (
                      <p className="mt-2 text-sm text-red-500">
                        {errors["bankDetails.accountHolderName"]}
                      </p>
                    )}
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="bankDetails.accountNumber"
                    className="block text-sm font-medium text-gray-300"
                  >
                    Account Number
                  </label>
                  <div className="mt-1">
                    <input
                      id="bankDetails.accountNumber"
                      name="bankDetails.accountNumber"
                      type="text"
                      required
                      value={formData.bankDetails.accountNumber}
                      onChange={handleChange}
                      className={`appearance-none block w-full px-3 py-2 border ${
                        errors["bankDetails.accountNumber"]
                          ? "border-red-500"
                          : "border-gray-700"
                      } bg-gray-800/50 rounded-lg shadow-sm placeholder-gray-400 
                      focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500 
                      text-white transition-colors sm:text-sm`}
                    />
                    {errors["bankDetails.accountNumber"] && (
                      <p className="mt-2 text-sm text-red-500">
                        {errors["bankDetails.accountNumber"]}
                      </p>
                    )}
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="bankDetails.routingNumber"
                    className="block text-sm font-medium text-gray-300"
                  >
                    Routing Number
                  </label>
                  <div className="mt-1">
                    <input
                      id="bankDetails.routingNumber"
                      name="bankDetails.routingNumber"
                      type="text"
                      required
                      value={formData.bankDetails.routingNumber}
                      onChange={handleChange}
                      className={`appearance-none block w-full px-3 py-2 border ${
                        errors["bankDetails.routingNumber"]
                          ? "border-red-500"
                          : "border-gray-700"
                      } bg-gray-800/50 rounded-lg shadow-sm placeholder-gray-400 
                      focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500 
                      text-white transition-colors sm:text-sm`}
                    />
                    {errors["bankDetails.routingNumber"] && (
                      <p className="mt-2 text-sm text-red-500">
                        {errors["bankDetails.routingNumber"]}
                      </p>
                    )}
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="bankDetails.swiftCode"
                    className="block text-sm font-medium text-gray-300"
                  >
                    SWIFT Code
                  </label>
                  <div className="mt-1">
                    <input
                      id="bankDetails.swiftCode"
                      name="bankDetails.swiftCode"
                      type="text"
                      required
                      value={formData.bankDetails.swiftCode}
                      onChange={handleChange}
                      className={`appearance-none block w-full px-3 py-2 border ${
                        errors["bankDetails.swiftCode"]
                          ? "border-red-500"
                          : "border-gray-700"
                      } bg-gray-800/50 rounded-lg shadow-sm placeholder-gray-400 
                      focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500 
                      text-white transition-colors sm:text-sm`}
                    />
                    {errors["bankDetails.swiftCode"] && (
                      <p className="mt-2 text-sm text-red-500">
                        {errors["bankDetails.swiftCode"]}
                      </p>
                    )}
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="bankDetails.ibanNumber"
                    className="block text-sm font-medium text-gray-300"
                  >
                    IBAN Number
                  </label>
                  <div className="mt-1">
                    <input
                      id="bankDetails.ibanNumber"
                      name="bankDetails.ibanNumber"
                      type="text"
                      required
                      value={formData.bankDetails.ibanNumber}
                      onChange={handleChange}
                      className={`appearance-none block w-full px-3 py-2 border ${
                        errors["bankDetails.ibanNumber"]
                          ? "border-red-500"
                          : "border-gray-700"
                      } bg-gray-800/50 rounded-lg shadow-sm placeholder-gray-400 
                      focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500 
                      text-white transition-colors sm:text-sm`}
                    />
                    {errors["bankDetails.ibanNumber"] && (
                      <p className="mt-2 text-sm text-red-500">
                        {errors["bankDetails.ibanNumber"]}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div> */}

            <div>
              <button
                type="submit"
                disabled={isLoading}
                className="w-full flex justify-center py-2.5 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white 
                bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-500 hover:to-purple-600
                focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 
                disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200
                transform hover:scale-[1.02] active:scale-[0.98]"
              >
                {isLoading ? (
                  <div className="flex items-center">
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Registering...
                  </div>
                ) : (
                  "Register"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
